// Appends the current variant's price to the "Ajouter au panier" button
// label, kept in sync whenever Dawn re-renders the price block on variant
// change (e.g. switching the Flocage option to a higher-priced variant).
class ProductSubmitPrice {
  constructor(root) {
    this.button = root.querySelector('.product-form__submit');
    this.priceBlock = root.querySelector('[id^="price-"]');
    this.labelEl = this.button ? this.button.querySelector('span') : null;

    if (!this.button || !this.priceBlock || !this.labelEl) return;

    this.baseLabel = this.labelEl.textContent.trim();

    this.observer = new MutationObserver(() => this.update());
    this.observer.observe(this.priceBlock, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    this.update();
  }

  update() {
    if (this.button.disabled || this.button.getAttribute('aria-disabled') === 'true') return;

    const priceEl = this.priceBlock.querySelector('.price-item--last');
    if (!priceEl) return;

    const priceText = priceEl.textContent.trim();
    if (!priceText) return;

    this.labelEl.textContent = `${this.baseLabel} — ${priceText}`;
  }
}

document.querySelectorAll('product-info').forEach((root) => new ProductSubmitPrice(root));
